module.exports = __webpack_public_path__ + "img/launch_male.7a823044.png";